import styles from "./SideBarSubMenu.module.css";

const SideBarSubMenu = ({ title, children }) => {
    return (
        <div className={styles.SubMenu}>
            <div className={styles.SubMenu_Title}>{title}</div>
            <div className={styles.SubMenu_Content}>{children}</div>
        </div>
    );
};

export default SideBarSubMenu;
